export const trMessages = {
  race: {
    rules: "3 dakika · kelime başına 6 hak · pas yok · en çok kelimeyi bul",
    title: "KELİME YARIŞI",
    resultTitle: "Yarış sonucu",
    won: "Kazandın",
    lost: "Kaybettin",
    draw: "Berabere",
    fewerAttempts: "Eşit kelimede daha az tahmin kazandırdı.",
    attempts: (yours: number, rival: number) => `Çözülen kelimelerdeki tahminler: ${yours} · ${rival}`,
    progress: (yours: number, rival: number) => `Kelime sırası: sen ${yours} · rakip ${rival}`,
    rematch: "Rövanş iste",
    rematchWaiting: (votes: number) => `Rakip bekleniyor · ${votes}/2`,
    leaveTitle: "Yarıştan ayrıl?",
    leaveMessage: "Şimdi çıkarsan hükmen kaybedersin.",
  },
  leaderboard: {
    title: "Liderlik tablosu",
    period: { weekly: "Haftalık", monthly: "Aylık", all: "Tüm zamanlar" },
    wins: "galibiyet",
    empty: "Bu dönemde henüz galibiyet yok.",
    failed: "Liderlik tablosu yüklenemedi.",
    boards: { duel: "Düello", timed: "3 Dakika" },
    boardLabel: "Tablo türü",
    timedScore: (words: number, attempts: number) => `${words} kelime · ${attempts} tahmin`,
    timedEmpty: "Bu dönemde henüz 3 dakika skoru yok.",
    timedHint: "Tek Başına Oyna · 3 dakika, bulduğun her kelimeye +30 saniye. Eşitlikte daha az tahmin önde.",
  },
  common: {
    showPassword: "Şifreyi göster",
    hidePassword: "Şifreyi gizle",
    loading: "Yükleniyor…",
    back: "Geri",
    close: "Kapat",
    cancel: "Vazgeç",
    stayInGame: "Oyunda kal",
    processing: "İşleniyor…",
    you: "SEN",
    friend: "ARKADAŞ",
    friends: "Arkadaşlar",
    friendlyMatch: "Arkadaş maçı",
    standardDuel: "Standart düello",
    returnToMatches: "Maçlara dön",
    tryAgain: "Tekrar dene",
  },
  board: {
    label: "Tahmin tahtası",
    hint: (position: number) => `${position}. kutucuğa yazıyorsun — bırakmak için ona tekrar dokun`,
    locked: "Kapalı tahmin hakkı",
    letter: (position: number, letter: string) => `${position}. harf: ${letter}`,
    emptyLetter: (position: number) => `${position}. harf, boş`,
    keyboard: "Türkçe klavye",
    draft: "Yazılan taslak",
    enter: "GİR",
    submit: "Tahmini gönder",
    backspace: "Son harfi sil",
    noGuesses: "Tahmin yok",
    guesses: "Tahminler",
  },
  howTo: {
    title: "Nasıl oynanır",
    intro: (length: number, attempts: number) => `${length} harfli gizli kelimeyi ${attempts} denemede bul. Her tahminden sonra kutucukların rengi sana ipucu verir.`,
    examples: [
      { word: "KİTAP", label: "Doğru yer", text: "K doğru harf ve doğru yerde." },
      { word: "SALON", label: "Başka yer", text: "L kelimede var ama başka yerde." },
      { word: "DEMİR", label: "Kelime dışı", text: "R bu kelimede hiç yok." },
    ],
  },
  ghost: {
    colorsOnly: "SADECE RENKLERİ GÖRÜRSÜN",
    solved: (attempt: number) => `BULDU · ${attempt}. DENEME`,
    live: "CANLI",
    attempt: "DENEME",
  },
  clock: { shortened: "SÜRE KISALDI", remaining: "KALAN" },
  countdown: { nextWord: "Sonraki kelime" },
  result: {
    won: "Buldun",
    finished: "Bitti",
    solvedIn: (attempts: number) => `${attempts}. denemede bildin.`,
    attemptsUsed: (attempts: number) => `${attempts} hakkın da bitti.`,
    word: "Kelime",
    guesses: "Tahminlerin",
    compareFriends: "Arkadaşlarınla karşılaştır",
    newWord: "Yeni kelime",
  },
  feedback: {
    lengthRequired: (length: number) => `${length} harf gerekiyor`,
    notInList: "Bu kelime listede yok",
    guessFailed: "Tahmin gönderilemedi",
    guessConnectionFailed: "Tahmin gönderilemedi, bağlantını kontrol et",
    opponentSolved: (name: string, attempt: number) => `${name} kelimeyi ${attempt}. denemede buldu`,
    opponent: "Rakibin",
    opponentWatchFailed: "Rakip görünümü açılamadı",
    serverUnavailable: "Sunucuya ulaşılamadı, tekrar dene",
  },
  install: {
    title: "Telefonuna kur",
    prompt: "Ana ekrandan tam ekran açılır, Tek Başına Oyna modu çevrimdışı da çalışır.",
    ios: "Safari'de paylaş düğmesine dokun, ardından “Ana Ekrana Ekle”yi seç.",
    install: "Kur",
  },
  share: {
    copied: "Sonuç panoya kopyalandı, görsel indirildi",
    downloaded: "Görsel indirildi",
    failed: "Paylaşılamadı",
    imageFailed: "Görsel oluşturulamadı",
    preparing: "Hazırlanıyor…",
    result: "Sonucu paylaş",
    showLetters: "Harfler de görünsün",
    spoilerHint: "Görseli görüp bugünü oynamamış olana cevabı verir",
  },
  meaning: {
    loading: "Bakılıyor…",
    ask: (word: string) => `“${word}” ne demek?`,
    missing: "Bu kelimenin sözlükte karşılığı bulunamadı.",
    failed: "Anlam alınamadı — tekrar dene",
    source: (name: string) => `Kaynak: ${name}`,
  },
  rematch: {
    request: (name: string) => `${name} rövanş istiyor`,
    seconds: (seconds: number) => `${seconds} sn`,
    decline: "Reddet",
    accept: "Kabul et",
    declined: "Rakibin rövanşı reddetti",
  },
  dailyFriends: {
    title: "Arkadaşlar bugün",
    loadFailed: "Liste alınamadı. Tekrar dene.",
    empty: "Henüz arkadaşın yok. Arkadaş ekleyince bugünkü kelimeyi kaçta bitirdiklerini burada görürsün.",
    status: { solved: "buldu", failed: "bulamadı", playing: "oynuyor", none: "oynamadı" },
  },
  friendHistory: {
    badge: { win: "G", loss: "M", draw: "B" },
    win: "KAZANDIN",
    loss: "KAYBETTİN",
    draw: "BERABERE",
    lastTen: (name: string) => `${name} · SON 10`,
    loadFailed: "Maçlar alınamadı. Bağlantını kontrol edip tekrar dene.",
    empty: "Bu arkadaşınla henüz bitmiş bir maçın yok.",
  },
  friendsScreen: {
    title: "Arkadaşlar",
    changes: {
      profileUpdated: "Arkadaşın kullanıcı adını güncelledi",
      created: "Yeni arkadaşlık isteği geldi",
      accepted: "Arkadaşlık isteğin kabul edildi",
      declined: "Arkadaşlık isteğin reddedildi",
      removed: "Arkadaşlık sona erdi",
      updated: "Arkadaş listesi güncellendi",
    },
    listFailed: "Arkadaş listesi alınamadı",
    minSearch: "En az 3 karakter yaz",
    searchFailed: "Arama yapılamadı",
    nowFriends: "Artık arkadaşsınız",
    requestSent: "İstek gönderildi",
    requestFailed: "İstek gönderilemedi",
    removed: (name: string) => `${name} arkadaşlıktan çıkarıldı`,
    removeFailed: "Arkadaş çıkarılamadı",
    actionFailed: "İşlem tamamlanamadı",
    challengeSent: "Meydan okuma gönderildi",
    challengeCancelled: (seconds: number) => `Meydan okuma iptal edildi · ${seconds} sn sonra yeniden gönderebilirsin`,
    cancelChallenge: "İptal et",
    cancellingChallenge: "İptal ediliyor…",
    challenged: "Sana meydan okundu",
    pendingChallenges: "Yanıt bekleyen meydan okumalar",
    friendRequests: "Arkadaşlık istekleri",
    addFriend: "Arkadaş ekle",
    username: "Kullanıcı adı",
    searchUsername: "Kullanıcı adı ara",
    search: "Ara",
    nobodyFound: "Bu adla birebir eşleşen kimse yok.",
    searchHint: "Kullanıcı adının tamamını yaz; büyük-küçük harf fark etmez.",
    add: "Ekle",
    yourFriends: "Arkadaşların",
    noFriends: "Henüz arkadaşın yok. Yukarıdan kullanıcı adıyla arayıp ekleyebilirsin.",
    openHistory: (name: string) => `${name} ile son maçları aç`,
    showHistory: "Maç geçmişini göster",
    showOptions: (name: string) => `${name} için seçenekleri göster`,
    hideOptions: (name: string) => `${name} için seçenekleri gizle`,
    record: (wins: number, losses: number, draws: number) => `${wins} galibiyet · ${losses} mağlubiyet · ${draws} berabere`,
    watch: "İzle",
    watchTeam: "2v2 İzle",
    teamSpectatorsDisabled: "2v2 maçında · İzleyici kapalı",
    prepareSettings: "Ayarları hazırlayabilirsin; davet süresi dolunca gönderilir",
    offline: "Arkadaşın çevrimdışı",
    offlineShort: "Çevrimdışı",
    settingsWithSeconds: (seconds: number) => `Ayarlar · ${seconds} sn`,
    challenge: "Meydan oku",
    removeLabel: (name: string) => `${name} adlı arkadaşı çıkar`,
    remove: "Arkadaşlıktan çıkar",
    sentRequests: "Gönderilen istekler",
    awaitingResponse: "Yanıt bekleniyor",
    removeTitle: "Arkadaşlıktan çıkarılsın mı?",
    removeMessage: (name: string) => `${name} listenden düşecek, sen de onun listesinden. Yeniden eklemek için tekrar arayıp istek göndermen gerekir.`,
    removeConfirm: "Çıkar",
    matchSettings: "MAÇ AYARLARI",
    settingsTitle: (name: string) => `${name} · MAÇ AYARLARI`,
    duration: "Süre",
    guessLimit: "Tahmin hakkı",
    victory: "Kazanma biçimi",
    pressure: "Kelime bulununca 30 saniye baskısı",
    on: "Açık",
    off: "Kapalı",
    pressureUnused: "İlk doğru tahmin maçı anında bitirdiği için bu ayar kullanılmaz.",
    resetStandard: "Standart ayarlara dön",
    sending: "Gönderiliyor…",
    sendAfter: (seconds: number) => `${seconds} sn sonra gönder`,
    sendChallenge: "Meydan okumayı gönder",
  },
  invites: {
    title: "Oyun davetleri",
    duel: "1v1 DAVETİ",
    team: "2v2 DAVETİ",
    from: (name: string) => `${name} seni oyuna davet ediyor`,
    remaining: (seconds: number) => `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")} kaldı`,
    dismiss: "Bildirimi gizle",
    more: (count: number) => `+${count} davet`,
    teamSummary: (code: string, minutes: number, players: number) => `${code} · ${minutes} dk · ${players}/4 oyuncu`,
  },
  deleteAccount: {
    title: "HESABI SİL",
    description: "Hesabın ve ona bağlı her şey kalıcı olarak silinir: arkadaşların, düello geçmişin, günlük kelime serilerin ve tüm istatistiklerin. Bu işlem geri alınamaz.",
    password: "Şifren",
    confirmName: (name: string) => `Onaylamak için “${name}” yaz`,
    googleProof: "Hesabın Google ile açıldığı için şifresi yok. Silmeyi onaylamak için Google hesabınla yeniden doğrula.",
    appleProof: "Hesabın Apple ile açıldığı için şifresi yok. Silmeyi onaylamak için Apple ile yeniden doğrula; Apple bağlantısı da kaldırılır.",
    appleOnlyElsewhere: "Bu hesap Apple ile açıldı; Apple doğrulaması yalnızca iPhone uygulamasında var. Hesabı iPhone uygulamasından Profil → Hesabı sil ile ya da hesap silme sayfasındaki yolla silebilirsin.",
    deleting: "Siliniyor…",
    deleteForever: "Kalıcı olarak sil",
    failed: "Hesap silinemedi",
  },
  auth: {
    passwordMismatch: "Şifreler aynı değil",
    connectionFailed: "Bağlantı kurulamadı",
    googleFailed: "Google ile giriş yapılamadı",
    appleFailed: "Apple ile giriş yapılamadı",
    createFailed: "Hesap oluşturulamadı",
    chooseUsername: "Kullanıcı adı seç",
    googleStep: (email: string) => `${email} ile giriş yapıldı. Son bir adım: arkadaşların seni bulacağı kullanıcı adını seç.`,
    username: "Kullanıcı adı",
    usernameRule: "3-20 karakter; harf, rakam ve alt çizgi. Sonradan profilden değiştirilebilir.",
    forgotPassword: "Şifremi unuttum",
    forgotUsername: "Kullanıcı adımı unuttum",
    recoveryHint: "Kayıtlı e-posta adresini gir. Hesap varsa sana bir e-posta göndereceğiz.",
    recoverySent: "Hesap varsa e-posta gönderildi. Gelen kutunu kontrol et.",
    sendRecovery: "E-posta gönder",
    wait: "Bekle…",
    createAccount: "Hesabı oluştur",
    signIn: "Giriş yap",
    register: "Hesap aç",
    or: "ya da",
    loginField: "E-posta ya da kullanıcı adı",
    email: "E-posta",
    usernameHint: "3–20 karakter; harf, rakam ve _ kullanabilirsin. Arkadaşların seni bu adla bulacak.",
    password: "Şifre",
    passwordMin: "En az 8 karakter.",
    repeatPassword: "Şifreyi tekrar gir",
    privacyPrefix: "Hesap açarak",
    privacyPolicy: "gizlilik politikasını",
    privacySuffix: "kabul etmiş olursun.",
    needAccount: "Hesabın yok mu? Hesap aç",
    haveAccount: "Zaten hesabın var mı? Giriş yap",
  },
  home: {
    streakLabel: "seri",
    openProfile: (username: string) => `Profil: ${username}`,
    brandTop: "MUHTEŞEM",
    brandBottom: "KELİME",
    brandAccent: "+",
    howTo: "Nasıl oynanır",
    accountReason: "Giriş yaptığında düello, günlük kelime ve arkadaşlar açılır.",
    signIn: "Giriş yap",
    offline: "Çevrimdışısın. Tek Başına Oyna modu çalışmaya devam ediyor; düello ve günlük kelime bağlantı ister.",
    duelReason: "Düello için hesabına giriş yapman gerekiyor.",
    liveMatch: "CANLI EŞLEŞME",
    connectionRequired: "BAĞLANTI GEREKİR",
    duel: "DÜELLO",
    duelDescription: "Rakiple aynı kelime, 3 dakika. En az denemede bulan kazanır.",
    findOpponent: "Rakip bul",
    wins: "GALİBİYET",
    losses: "MAĞLUBİYET",
    teamReason: "Takımlı düello için hesabına giriş yapman gerekiyor.",
    team: "TAKIMLI DÜELLO",
    teamDescription: "İki koridor, dört oyuncu. Süre bitene kadar takımınla en fazla kelimeyi bul.",
    dailyReason: "Günlük kelime için giriş yapman gerekiyor.",
    daily: "GÜNLÜK KELİME",
    dailyAuthed: "Herkes aynı kelimede. Serin sürüyor.",
    dailyAnon: "Herkes bugün aynı kelimede.",
    solo: "TEK BAŞINA OYNA",
    soloDescription: "Sınırsız kelime ya da süreye karşı en çok kelime.",
    friendsReason: "Arkadaş eklemek için giriş yapman gerekiyor.",
    friends: "ARKADAŞINLA OYNA",
    friendsDescription: "Ekle, doğrudan meydan oku.",
    requests: (count: number) => `${count} İSTEK`,
    friendsOnline: (count: number) => `${count} ÇEVRİMİÇİ`,
    historyReason: "Düello ve arkadaş maçı geçmişi için giriş yapman gerekiyor.",
    matchHistory: "MAÇ GEÇMİŞİ",
    matchHistoryDescription: "Düello, 2v2, yarış, tek başına ve arkadaş maçlarını incele.",
  },
  team: {
    title: "TAKIMLI DÜELLO",
    browserSubtitle: "Takımını kur, koridorunu kazan",
    helpOpen: "Takımlı düello nasıl oynanır?",
    helpTitle: "TAKIMLI DÜELLO NASIL OYNANIR?",
    helpIntro: "Dört oyuncu, iki takım, iki koridor. Süre dolana kadar art arda kelime çözersin; takımının topladığı kelime sayısı kazandırır.",
    helpRules: [
      { title: "Koridorun rakibin belli", text: "Takımından biri X, diğeri Y koridoruna düşer. Karşı takımda da öyle. Seninle aynı koridordaki rakip, tam olarak senin kelimelerini çözüyor — aranızdaki fark hız." },
      { title: "Kelime bitince yenisi gelir", text: "Kelimeyi bulunca ya da 6 hakkın dolunca kısa bir geçişin ardından o koridorun sıradaki kelimesi açılır. Bulamamak seni durdurmaz, sadece deneme harcatır." },
      { title: "Takım arkadaşını görürsün", text: "Takım arkadaşın öbür koridorda, başka bir kelimede: harflerini açıkça görürsün. Koridor rakibin seninle aynı kelimede olduğu için ondan yalnız renkleri görürsün." },
      { title: "Kazanan takım", text: "Süre dolduğunda çok kelime bulan takım kazanır. Kelime sayısı eşitse tamamlanan kelimelerde daha az deneme harcayan takım öne geçer." },
      { title: "Çıkarsan hükmen", text: "Maç sırasında çıkan ya da bağlantısı 30 saniye dönmeyen oyuncunun takımı hükmen kaybeder." },
    ],
    yourLane: "SEN",
    versus: "vs",
    waitingLobbies: "AÇIK LOBİLER",
    liveLobbies: "CANLI MAÇLAR",
    emptyWaiting: "Şu an açık bekleme lobisi yok.",
    emptyLive: "Şu an izlenebilen canlı 2v2 maçı yok.",
    createLobby: "Lobi kur",
    joinCode: "Kodla katıl",
    code: "Lobi kodu",
    codePlaceholder: "6 karakter",
    join: "Katıl",
    watch: "İzle",
    full: "LOBI DOLU",
    fullHint: "Dört oyuncu yerini almış. Maç canlıysa ve izleyici açıksa izleyebilirsin.",
    settings: "LOBİ AYARLARI",
    settingsSummary: (minutes: number, spectators: string, visibility: string) => `${minutes} dk · İzleyici ${spectators} · ${visibility}`,
    inviteFriends: "Arkadaşlarını davet et",
    inviteFriendsTitle: "ARKADAŞLARINI DAVET ET",
    inviteFriendsHint: "Çevrimdışı arkadaşların da daveti beş dakika içinde bağlanırsa görebilir.",
    invite: "Davet et",
    invited: "Davet edildi",
    inLobby: "Lobide",
    teamInviteSent: "2v2 daveti gönderildi",
    noInviteFriends: "Davet edebileceğin bir arkadaşın yok.",
    duration: "Süre",
    minutes: (value: number) => `${value} dakika`,
    spectators: "İzleyiciler",
    visibility: "Görünürlük",
    public: "Herkese açık",
    codeOnly: "Yalnız kodla",
    on: "Açık",
    off: "Kapalı",
    create: "Lobiyi oluştur",
    lobby: "2v2 LOBİSİ",
    shareInvite: "Davet bağlantısını paylaş",
    inviteShareTitle: "2v2 lobisine gel",
    inviteShareText: (code: string) => `Muhteşem Kelime+ 2v2 lobime katıl (kod: ${code})`,
    inviteCopied: "Davet bağlantısı kopyalandı",
    inviteSignIn: "Davet edildiğin 2v2 lobisine katılmak için giriş yap.",
    copyCode: "Kodu kopyala",
    copied: "Lobi kodu kopyalandı",
    host: "KURUCU",
    connected: "BAĞLI",
    disconnected: "BAĞLANTI KOPTU",
    teamA: "A TAKIMI",
    teamB: "B TAKIMI",
    moveA: "A takımına geç",
    moveB: "B takımına geç",
    kick: "Çıkar",
    start: "Maçı başlat",
    startHint: "Başlamak için dört bağlı oyuncu ve tam 2–2 dağılım gerekir.",
    leave: "Lobiden çık",
    lane: (lane: string) => `${lane} KORİDORU`,
    teammate: "Takım",
    laneOpponent: "Koridor rakibi",
    words: "KELİME",
    attempts: "DENEME",
    nextWord: "SONRAKİ KELİME HAZIRLANIYOR",
    spectatorCount: (count: number) => `${count} KİŞİ İZLİYOR`,
    matchOver: "2v2 MAÇI BİTTİ",
    won: "TAKIMIN KAZANDI",
    lost: "TAKIMIN KAYBETTİ",
    draw: "BERABERE",
    forfeit: "HÜKMEN SONUÇ",
    scoreReason: "Daha fazla kelime bulundu.",
    attemptsReason: "Kelime sayısı eşitti; daha az toplam deneme kazandırdı.",
    rematch: "Rövanş oyu",
    rematchVotes: (votes: number) => `${votes}/4 RÖVANŞ`,
    returnLobby: "Lobiye dön",
    browse: "Lobilere dön",
    loadFailed: "2v2 durumu alınamadı. Tekrar dene.",
    noRounds: "Tamamlanan kelime yok",
    historyEmpty: "Henüz bitmiş bir 2v2 maçın yok.",
  },
  support: {
    open: "Projeye destek ol",
    title: "PROJEYE DESTEK OL",
    description: "Muhteşem Kelime+ bağımsız geliştiriliyor. Dilersen geliştirme, sunucu ve alan adı giderlerine gönüllü destek olabilirsin.",
    noBenefits: "Destek hiçbir oyun içi avantaj, özel içerik veya rozet sağlamaz.",
    externalNotice: "Devam ettiğinde Kreosus adlı harici destek sayfası yeni sekmede açılır.",
    notNow: "Şimdi değil",
    openKreosus: "Kreosus'ta destek ol",
  },
  sound: {
    open: "Ses ayarlarını aç",
    title: "SES AYARLARI",
    description: "Oyun ve bildirim seslerinin seviyesini bu cihaz için ayarla.",
    volume: "Ses seviyesi",
    percent: (value: number) => `%${value}`,
    mute: "Sessize al",
    unmute: "Sesi aç",
    preview: "Sesi dene",
    on: "Sesler açık",
    off: "Sesler kapalı",
    enable: "Sesleri aç",
    disable: "Sesleri kapat",
  },
  solo: {
    title: "Tek Başına Oyna",
    unlimited: "Sınırsız kelime",
    loadingWords: "Kelimeler yükleniyor…",
    listFailed: "Kelime listesi yüklenemedi",
    listFailedHint: "Bağlantını kontrol edip tekrar dene. Liste bir kez indikten sonra çevrimdışı da çalışır.",
    showResult: "Sonucu gör",
    newWord: "Yeni kelime",
    exitTitle: "Tek Başına Oyna modundan çıkılsın mı?",
    exitMessage: "Bu oyun yarım kalacak. Tek Başına Oyna moduna yeniden girdiğinde yeni kelimeyle boş bir tahta açılacak.",
    exit: "Çık ve bitir",
    historyTitle: "TEK BAŞINA GEÇMİŞİ",
    lastGames: (count: number) => `Son ${count} oyun`,
    historyEmpty: "Henüz bitirdiğin tek başına oyun yok. Bir kelimeyi bitirdiğinde burada görünecek.",
    found: "BULDUN",
    missed: "BULAMADIN",
    foundIn: (attempts: number) => `${attempts}. denemede bildin.`,
    allAttemptsUsed: (attempts: number) => `${attempts} hakkın da bitti. Kelime:`,
    modeLabel: "Oyun türü",
    modeClassic: "KLASİK",
    modeTimed: "3 DAKİKA",
    timedSubtitle: "Bulduğun her kelime +30 saniye",
    timedRules: "3 dakika · kelime başına 6 hak · bulduğun her kelime 30 saniye ekler · 6 hakta bulamazsan oyun biter · en çok kelimeyi bul",
    timedTieBreak: "Eşit kelimede, bulduğun kelimelerde daha az tahmin yapan önde.",
    timedStart: "Başla",
    timedStarting: "Hazırlanıyor…",
    timedSignInTitle: "HESAP GEREKİYOR",
    timedSignInHint: "3 dakika skorların hesabında saklanır ve arkadaşlarınla karşılaştırılır. Klasik mod giriş yapmadan da çalışır.",
    timedSignInReason: "3 dakika modunda skorunu kaydetmek için giriş yapman gerekiyor.",
    signIn: "Giriş yap",
    timedOfflineTitle: "BAĞLANTI GEREKİYOR",
    timedOfflineHint: "3 dakika modu sunucuda oynanır. Klasik mod çevrimdışı da çalışır.",
    timedStartFailed: "Oyun başlatılamadı. Bağlantını kontrol edip tekrar dene.",
    timedWords: "KELİME",
    timedWordNumber: "SIRA",
    timedRoundsTitle: "KELİMELER",
    timedNextWord: (answer: string) => `Kelime: ${answer}`,
    timedBonus: (answer: string) => `+30 saniye · Kelime: ${answer}`,
    timedResultTitle: "3 Dakika sonucu",
    timedTimeUp: "Süre doldu",
    timedOutOfGuesses: "Hakların bitti",
    timedWordsFound: (count: number) => `${count} kelime buldun`,
    timedAttempts: (attempts: number) => `Bulduğun kelimelerde ${attempts} tahmin`,
    timedNewRecord: "YENİ REKOR!",
    timedBest: (words: number, attempts: number) => `Rekorun: ${words} kelime · ${attempts} tahmin`,
    timedNoRounds: "Bu koşuda tamamlanan kelime yok.",
    timedRecordTitle: "REKORUN",
    timedRecordTag: "REKOR",
    timedRecentTitle: "SON 5 DENEME",
    timedRecentHint: "Rapor için dokun",
    timedRecentEmpty: "Henüz bitmiş denemen yok. İlk denemen burada görünecek.",
    timedRecentFailed: "Denemeler alınamadı.",
    timedUnfinished: (guesses: number) => (guesses > 0 ? `${guesses} tahmin · süre doldu` : "süre doldu"),
    timedResultLoading: "Sonuç hesaplanıyor…",
    timedPlayAgain: "Tekrar oyna",
    timedLeaveTitle: "3 dakika koşusu bitirilsin mi?",
    timedLeaveMessage: "Koşu şu ana kadar bulduğun kelimelerle biter ve skorun kaydedilir.",
    timedLeave: "Bitir ve çık",
    switchTitle: "Mod değiştirilsin mi?",
    switchMessage: "Bu kelime yarım kalacak. Klasik moda döndüğünde yeni bir kelime açılır.",
    switchConfirm: "Değiştir",
    rankingTitle: "ARKADAŞLARINLA KARŞILAŞTIR",
    rankingHint: "Tüm zamanların rekorları",
    rankingLoading: "Sıralama yükleniyor…",
    rankingFailed: "Sıralama alınamadı.",
    rankingEmpty: "Arkadaş ekle, rekorlarınızı karşılaştırın.",
    rankingScore: (words: number, attempts: number) => `${words} kelime · ${attempts} tahmin`,
    rankingNotPlayed: "Henüz oynamadı",
  },
  profile: {
    changeUsername: "Kullanıcı adını değiştir",
    newUsername: "Yeni kullanıcı adı",
    saveUsername: "Kaydet",
    nextUsernameChange: (date: string) => `Yeniden değiştirebileceğin tarih: ${date}`,
    duelRecordTitle: "Düello karnesi",
    duelRecord: (wins: number, losses: number, draws: number) => `${wins} galibiyet · ${losses} mağlubiyet · ${draws} beraberlik`,
    title: "Profil",
    statistics: "İSTATİSTİKLER",
    supporter: "Reklamsız Oyun sahibi",
    googleButton: "Google ile devam et",
    appleButton: "Apple ile devam et",
    removeAds: "Reklamsız Oyun",
    removeAdsDescription: "Tek seferlik satın alma. Bu oyun hesabına bağlanır; reklamlar kapanır ve adının yanında altın yıldız görünür.",
    buy: "Satın al",
    restore: "Satın alımları geri yükle",
    purchasePending: "Ödeme beklemede. Tamamlanınca yeniden geri yükle.",
    purchaseWrongAccount: "Bu satın alma başka bir oyun hesabına bağlı. O hesapla giriş yap.",
    purchaseFailed: "Satın alma doğrulanamadı. Tekrar dene.",
    purchaseOwned: "Reklamsız Oyun etkin.",
    purchaseUnavailable: "Satın alma şu anda kapalı.",
    adPrivacy: "Reklam gizlilik tercihleri",
    accountRequired: "Hesap istatistiklerini görmek için giriş yap.",
    signIn: "Giriş yap",
    exportData: "Tek başına verilerini dışa aktar",
    importData: "Tek başına verilerini içe aktar",
    importDone: "Veriler içe aktarıldı.",
    importFailed: "Dosya geçersiz veya okunamadı.",
    duel: "Düello",
    wins: "Galibiyet",
    losses: "Mağlubiyet",
    draw: "Berabere",
    winRate: "Kazanma oranı",
    wordPerformance: "Kelime performansı · standart ve arkadaş maçları",
    findRate: "Bulma oranı",
    friendly: "Arkadaş maçları",
    daily: "Günlük kelime",
    currentStreak: "Güncel seri",
    longestStreak: "En uzun seri",
    solo: "Tek başına oyna",
    team: "2v2",
    teamWords: "Toplam bulunan kelime",
    teamAverage: "Tamamlanan kelime başına ort. deneme",
    localGames: "Bu cihazdaki tüm tamamlanmış oyunlar",
    changePassword: "Şifreyi değiştir",
    currentPassword: "Mevcut şifre",
    newPassword: "Yeni şifre",
    repeatNewPassword: "Yeni şifre (tekrar)",
    savePassword: "Şifreyi kaydet",
    passwordChanged: "Şifren değiştirildi. Diğer cihazlarda yeniden giriş yapman gerekecek.",
    statTabs: { duel: "Düello", friendly: "Arkadaş", daily: "Günlük", team: "2v2", solo: "Tek başına", timed: "3 Dakika" },
    emptyStats: {
      duel: "Henüz düello oynamadın. İlk maçından sonra sonuçların burada görünecek.",
      friendly: "Henüz arkadaş maçı oynamadın.",
      daily: "Henüz günlük kelimeyi oynamadın.",
      team: "Henüz 2v2 maçı oynamadın.",
      solo: "Bu cihazda henüz tamamlanmış Tek Başına oyunu yok.",
      timed: "Henüz bitmiş 3 dakika koşun yok.",
    },
    timedRuns: "Koşu",
    timedBest: "Rekor (kelime)",
    timedAverageWords: "Koşu başına ort. kelime",
    timedTotalWords: "Toplam bulunan kelime",
    timedWordPerformance: "Kelime performansı · 3 dakika koşuları",
    loadFailed: "İstatistik alınamadı. Bağlantını kontrol edip tekrar dene.",
    appearance: "Görünüm",
    themeLabel: "Tema",
    themes: { system: "Sisteme uy", dark: "Gece", light: "Gündüz" },
    keyboardLabel: "Tuş dizilimi",
    keyboardOptions: { default: "Sil solda", swapped: "Enter solda" },
    soundRow: (volume: number) => `Ses: %${volume}`,
    logout: "Çıkış yap",
    delete: "Hesabı sil",
    deleteHint: "Hesabını silmek tüm verilerini kalıcı olarak kaldırır.",
    privacy: "Gizlilik politikası",
    found: "Bulundu",
    missed: "Bulunamadı",
    averageAttempts: "Ort. deneme",
    attemptDistribution: "Kaçıncı denemede bulundu",
  },
  daily: {
    title: "Günlük kelime",
    loading: "Bugünkü tahta yükleniyor…",
    loadFailed: "Bugünkü kelime alınamadı",
    connectionHint: "Günlük kelime sunucudan doğrulanıyor, bu yüzden bağlantı gerekiyor. Çevrimdışıyken Tek Başına Oyna modunu oynayabilirsin.",
    streak: (day: string, count: number) => `${day} · ${count} günlük seri`,
    showResult: "Sonucu gör",
    home: "Ana ekrana dön",
    exitTitle: "Günlük oyundan çıkılsın mı?",
    exitMessage: "Gönderdiğin tahminler korunacak. Yarım bıraktığın satır temizlenecek ve yeniden girdiğinde kaldığın tahtadan devam edeceksin.",
    exit: "Çık",
  },
  duelHistory: {
    title: "MAÇ GEÇMİŞİ",
    lastTen: "Her sekmede son 10 oyun",
    tabsLabel: "Geçmiş türü",
    tabs: {
      competitive: "Düello",
      solo: "Tek Başına",
      friendly: "Arkadaşlar",
      race: "Yarış",
      team: "2v2",
      timed: "3 Dakika",
    },
    accountRequired: "HESAP GEREKİYOR",
    accountRequiredHint: "Düello ve arkadaş maçların hesabında saklanır. Bu geçmişi görmek için giriş yap.",
    signIn: "Giriş yap",
    connectionRequired: "BAĞLANTI GEREKİYOR",
    connectionRequiredHint: "Bu maçlar sunucuda saklanır. Tek Başına geçmişini çevrimdışı incelemeye devam edebilirsin.",
    loadFailed: "Geçmiş alınamadı. Bağlantını kontrol edip tekrar dene.",
    competitiveEmpty: "Henüz bitmiş standart düellon yok. İlk maçını oynadığında burada görünecek.",
    friendlyEmpty: "Henüz bitmiş arkadaş maçın yok. Bir arkadaşına meydan okuduğunda burada görünecek.",
    raceEmpty: "Henüz bitmiş kelime yarışın yok.",
    timedEmpty: "Henüz bitmiş 3 dakika koşun yok. Tek Başına Oyna'da 3 Dakika sekmesinden başlayabilirsin.",
    teamEmpty: "Henüz bitmiş bir 2v2 maçın yok. Takımını kurduğunda burada görünecek.",
  },
  spectate: {
    title: "İZLE",
    connecting: "Maça bağlanılıyor…",
    failed: "Maç izlenemiyor",
    return: "Geri dön",
    matchOver: "MAÇ BİTTİ",
    winner: (name: string) => `${name} KAZANDI`,
    draw: "BERABERE",
    backToFriends: "Arkadaşlara dön",
    live: "CANLI",
    bothLetters: "İkisi de arkadaşın olduğu için tahminleri harfleriyle görüyorsun.",
    oneLetters: (name: string) => `${name} arkadaşın: tahminlerini harfleriyle görüyorsun. Rakibinin yalnızca renkleri açık.`,
    colorsOnly: "Yalnızca renkleri görürsün — harfler maç bitince açılır.",
    preparing: " İkisi de ilk tahminini hazırlıyor.",
  },
  duel: {
    addFriend: "Arkadaş ekle",
    friendRequestSent: "İstek gönderildi",
    acceptFriend: "İsteği kabul et",
    alreadyFriends: "Arkadaşsınız",
    record: (played: number, wins: number, losses: number, draws: number, rate: string) =>
      `${played} maç · ${wins}G ${losses}M ${draws}B · ${rate}`,
    title: "DÜELLO",
    friendlyTitle: "ARKADAŞ MAÇI",
    queue: "KUYRUKTASIN",
    matchmakingOpen: "CANLI EŞLEŞME AÇIK",
    searching: "RAKİP ARANIYOR",
    challenge: "RAKİBİNİ YEN.",
    searchHint: "Eşleşme bulunur bulunmaz tahta açılacak.",
    intro: (attempts: number) => `İkinize de aynı kelime verilir. 3 dakika, ${attempts} hak. En az denemede bulan kazanır — oynarken yalnızca renkleri görür, kendi turun bitince rakip tahtasını açabilirsin.`,
    nobodyOnline: "Şu an çevrimiçi başka oyuncu yok.",
    early: "Buraya erken geldin",
    aloneHint: "Arkadaşını davet et ya da günlük kelimeyi oyna.",
    keepWaiting: "Kuyrukta beklemeye devam et",
    inviteFriend: "Arkadaşına meydan oku",
    shareApp: "Uygulamayı paylaş",
    shared: "Uygulama bağlantısı kopyalandı",
    playersOnline: (count: number) => `${count} oyuncu çevrimiçi`,
    searchingSeconds: (seconds: number) => `${seconds} saniyedir aranıyor`,
    searchingMinutes: (minutes: number) => `${minutes} dakikadır aranıyor`,
    queueEmpty: "kuyrukta senden başka kimse yok",
    stopSearch: "Aramayı durdur",
    findOpponent: "Rakip bul",
    wins: "GALİBİYET",
    losses: "MAĞLUBİYET",
    leaveTitle: "Maçtan çıkılsın mı?",
    stopTitle: "Arama durdurulsun mu?",
    leaveMessage: "Çıkarsan hükmen kaybedersin ve rakibine galibiyet yazılır.",
    stopMessage: "Rakip araması durdurulacak ve ana ekrana döneceksin.",
    forfeit: "Hükmen çık",
    stop: "Aramayı bırak",
    opponent: "RAKİP",
    matchFound: "Eşleşme bulundu",
    sameWord: "AYNI KELİME",
    minuteCount: (value: number) => `${value} DAKİKA`,
    attemptCount: (value: number) => `${value} HAK`,
    watching: (count: number) => `${count} KİŞİ İZLİYOR`,
    live: "CANLI",
    sessionScoreTitle: "SON 3 SAAT",
    sessionDraws: (count: number) => `${count} BERABERLİK`,
    tickerSolved: (name: string) => `${name} KELİMEYİ BULDU — SIRA SENDE, SÜREN İŞLİYOR`,
    tickerGuess: (name: string, attempt: number) => `${name} ${attempt}. TAHMİNİNİ GÖNDERDİ — BASKI ARTIYOR`,
    tickerPreparing: (name: string) => `${name} İLK TAHMİNİNİ HAZIRLIYOR`,
    watchLabel: (name: string) => `${name} oyuncusunu canlı izle`,
    watchOpen: "CANLI HARFLER AÇIK",
    watchPrompt: "DOKUN · CANLI HARFLERİYLE İZLE",
    liveLetters: (name: string) => `${name} CANLI · HARFLER AÇIK`,
    openingBoard: "Rakip tahtası açılıyor…",
    ownBoard: "Kendi tahtana dön",
    showKeyboard: "Klavyeyi göster",
    hideKeyboard: "Klavyeyi gizle",
    keyboardReviewHint: "Harf durumlarını incele",
    draw: "BERABERE",
    won: "KAZANDIN",
    lost: "KAYBETTİN",
    matchOver: "MAÇ BİTTİ",
    rematchRequest: (name: string) => `${name} rövanş istiyor`,
    rematchSent: "Rövanş isteği gönderildi…",
    askRematch: "Rövanş iste",
    home: "Ana ekran",
    newOpponent: "Yeni rakip",
    firstWins: "İlk bulan kazanır",
    fewestWins: "Az denemede bulan kazanır",
    minutes: (value: number) => `${value} dk`,
    attempts: (value: number) => `${value} hak`,
    pressureOn: "30 sn baskı açık",
    pressureOff: "30 sn baskı kapalı",
    seconds: (value: string) => `${value} sn`,
    firstSolverWin: "Kelimeyi rakibinden önce buldun.",
    firstSolverLoss: (name: string) => `${name} kelimeyi önce buldu.`,
    forfeitWin: (name: string) => `${name} maçtan ayrıldı; hükmen kazandın.`,
    forfeitLoss: "Maçtan ayrıldın; hükmen kaybettin.",
    onlyYou: "Kelimeyi yalnız sen buldun.",
    onlyOpponent: (name: string) => `Kelimeyi yalnız ${name} buldu.`,
    fewerWin: (you: number, name: string, them: number) => `Sen ${you} tahminde, ${name} ${them} tahminde buldu. Daha az tahminle kazandın.`,
    fewerLoss: (name: string, them: number, you: number) => `${name} ${them} tahminde, sen ${you} tahminde buldun. Daha az tahmin kazandırdı.`,
    fasterWin: (attempts: number, difference: string) => `İkiniz de ${attempts} tahminde buldunuz; sen ${difference} daha hızlıydın.`,
    fasterLoss: (attempts: number, name: string, difference: string) => `İkiniz de ${attempts} tahminde buldunuz; ${name} ${difference} daha hızlıydı.`,
    noneSolved: "Süre sonunda ikiniz de kelimeyi bulamadınız.",
    identical: (attempts: number) => `İkiniz de ${attempts} tahminde buldunuz — berabere.`,
  },
  shareText: {
    daily: (day: string) => `GÜNLÜK KELİME · ${day}`,
    solo: "TEK BAŞINA",
    duel: "DÜELLO",
    dailySolved: (attempts: number) => `${attempts}. denemede buldum`,
    streakUp: (attempt: string, streak: number) => `${attempt}. Günlük serim ${streak} güne çıktı.`,
    streakRestart: (attempt: string) => `${attempt}. Günlük seriye yeniden başladım.`,
    dailyMissedBroken: (streak: number) => `Bugünkü kelimeyi bulamadım. ${streak} günlük serim bitti.`,
    dailyMissed: "Bugünkü kelimeyi bulamadım.",
    soloSolved: (attempts: number) => `${attempts}. denemede buldum.`,
    soloMissed: "Bu kelimeyi bulamadım.",
    duelDrawSolved: (name: string, attempts: number) => `${name} ile berabere kaldık — ikimiz de ${attempts} tahminde bulduk.`,
    duelDraw: (name: string) => `${name} ile berabere kaldık.`,
    duelWonScore: (name: string, you: number, them: number) => `${name} rakibimi ${you}-${them} yendim.`,
    duelWon: (name: string) => `${name} rakibimi yendim.`,
    duelLost: (name: string, them: number, you: number) => `${name} rakibime ${them}-${you} kaybettim.`,
    timed: "TEK BAŞINA · 3 DAKİKA",
    timedSolved: (words: number, attempts: number) => `3 Dakika modunda ${words} kelime buldum (${attempts} tahmin).`,
    timedRecord: (words: number, attempts: number) => `3 Dakika modunda ${words} kelime buldum (${attempts} tahmin). Yeni rekor!`,
    timedNone: "3 Dakika modunda kelime bulamadım.",
    timedWords: "KELİME",
  },
} as const;

export type CatalogShape<T> = {
  [K in keyof T]: T[K] extends (...args: infer Args) => string
    ? (...args: Args) => string
    : T[K] extends object
      ? CatalogShape<T[K]>
      : string;
};

export type Messages = CatalogShape<typeof trMessages>;
